"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertReduxSortModelToGraphQL = void 0;
const graphql_1 = require("../../../../../__generated__/graphql");
const attributes_1 = require("../../../../constants/attributes");
const REVIEWED_STATUS_FIELD = 'reviewedStatus';
const productOwnFields = [
    attributes_1.CustomProductAttributes.Name,
    attributes_1.CustomProductAttributes.CreatedAt,
    attributes_1.CustomProductAttributes.ExternalId,
];
const productMetadataFields = [
    attributes_1.CustomProductAttributes.LastAttributeUpdatedAt,
    attributes_1.CustomProductAttributes.LastEditedBy,
];
const directionToOrderByMap = {
    [0 /* SortDirection.Ascending */]: graphql_1.OrderBy.Asc,
    [1 /* SortDirection.Descending */]: graphql_1.OrderBy.Desc,
};
const directionToSortOrderMap = {
    [0 /* SortDirection.Ascending */]: graphql_1.SortOrder.Asc,
    [1 /* SortDirection.Descending */]: graphql_1.SortOrder.Desc,
};
const convertReduxSortModelToGraphQL = (tableSort, reviewStatus) => {
    var _a;
    if (!tableSort) {
        return undefined;
    }
    const apiCompatibleSort = {};
    const { key, direction, isAIEnriched } = tableSort;
    if (key === REVIEWED_STATUS_FIELD && reviewStatus) {
        apiCompatibleSort.productPresentationOrderBy = {
            isReviewed: {
                order: directionToOrderByMap[direction],
                attribute: reviewStatus.attribute,
                attributeType: reviewStatus.attributeType,
            },
        };
    }
    else if (productOwnFields.includes(key)) {
        apiCompatibleSort.product = {
            [key]: directionToOrderByMap[direction],
        };
    }
    else if (productMetadataFields.includes(key)) {
        apiCompatibleSort.product = {
            productMetadata: {},
        };
        if (key === attributes_1.CustomProductAttributes.LastEditedBy) {
            apiCompatibleSort.product.productMetadata = {
                lastEditedBy: {
                    name: directionToOrderByMap[direction],
                },
            };
        }
        else {
            apiCompatibleSort.product.productMetadata = {
                [key]: directionToOrderByMap[direction],
            };
        }
    }
    else if (key === attributes_1.CustomProductAttributes.ClassificationProductType) {
        apiCompatibleSort.category = {
            order: directionToSortOrderMap[direction],
        };
    }
    else {
        apiCompatibleSort.label = {
            label: key,
            order: directionToSortOrderMap[direction],
            /*
              Since we display only valid values for AIEnriched attributes and all values for original ones,
              we need to apply different sorting logic for each.
            */
            valueScope: isAIEnriched ? graphql_1.ProductLabelValueScope.Valid : graphql_1.ProductLabelValueScope.All,
        };
    }
    // Append a stable externalId tie-breaker. Keep it in the same namespace as the primary sort:
    // reviewed sort lives under the new `productPresentationOrderBy`, everything else under `product`.
    if (apiCompatibleSort.productPresentationOrderBy) {
        if (!apiCompatibleSort.productPresentationOrderBy.externalId) {
            apiCompatibleSort.productPresentationOrderBy.externalId = graphql_1.OrderBy.Asc;
        }
    }
    else if (!((_a = apiCompatibleSort.product) === null || _a === void 0 ? void 0 : _a.externalId)) {
        apiCompatibleSort.product = Object.assign(Object.assign({}, apiCompatibleSort.product), { externalId: graphql_1.OrderBy.Asc });
    }
    return apiCompatibleSort;
};
exports.convertReduxSortModelToGraphQL = convertReduxSortModelToGraphQL;
